var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CourseHeader',{attrs:{"title":"Impossible de charger les données","subtitle":"Veuillez réessayer dans quelques instants"},scopedSlots:_vm._u([{key:"logo",fn:function(){return [_c('img',{attrs:{"src":require("../../../assets/error.png"),"alt":"Logo erreur"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }